export const heroSlides = [
  {
    id: 1,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 1080'%3E%3Crect fill='%23e5e7eb' width='1920' height='1080'/%3E%3C/svg%3E",
    title: '点滴爱心',
    subtitle: '致敬平凡英雄',
    description: '19.9元=12瓶水,为城市守护者送上一份清凉',
  },
  {
    id: 2,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 1080'%3E%3Crect fill='%23e5e7eb' width='1920' height='1080'/%3E%3C/svg%3E",
    title: '温暖传递',
    subtitle: '关爱快递小哥',
    description: '每一瓶水都承载着您的爱心与关怀',
  },
  {
    id: 3,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1920 1080'%3E%3Crect fill='%23e5e7eb' width='1920' height='1080'/%3E%3C/svg%3E",
    title: '爱心接力',
    subtitle: '守护建设者',
    description: '让每一位辛勤工作的人感受到社会的温暖',
  },
];

export const statsData = [
  {
    id: 1,
    icon: 'ri-heart-fill',
    number: 156789,
    unit: '人次',
    label: '累计捐赠人次',
  },
  {
    id: 2,
    icon: 'ri-water-flash-fill',
    number: 2345678,
    unit: '瓶',
    label: '累计发放水瓶数',
  },
  {
    id: 3,
    icon: 'ri-map-pin-fill',
    number: 38,
    unit: '个区县',
    label: '覆盖区域',
  },
];

export const stories = [
  {
    id: 1,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 720 480'%3E%3Crect fill='%23e5e7eb' width='720' height='480'/%3E%3C/svg%3E",
    category: '环卫工人',
    title: '夏日里的一份清凉',
    excerpt: '李师傅是南岸区的一名环卫工人,每天凌晨4点就开始工作。当志愿者送来冰镇矿泉水时,他激动地说:"这份关心让我觉得自己的工作很有价值..."',
    views: 12543,
    date: '2026-06-15',
  },
  {
    id: 2,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 720 480'%3E%3Crect fill='%23e5e7eb' width='720' height='480'/%3E%3C/svg%3E",
    category: '快递员',
    title: '奔波中的温暖守护',
    excerpt: '快递小哥王强每天要送100多个包裹,夏天最怕的就是中暑。"点滴公益"让他在最需要的时候喝到了清凉的水,他说这是最贴心的关怀...',
    views: 9876,
    date: '2026-06-12',
  },
  {
    id: 3,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 720 480'%3E%3Crect fill='%23e5e7eb' width='720' height='480'/%3E%3C/svg%3E",
    category: '建筑工人',
    title: '工地上的甘泉',
    excerpt: '建筑工人张师傅在高温下坚守岗位,当收到爱心水时,他说:"这不仅是一瓶水,更是社会对我们的认可和尊重,让我们干活更有劲了..."',
    views: 8765,
    date: '2026-06-10',
  },
  {
    id: 4,
    image: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 720 480'%3E%3Crect fill='%23e5e7eb' width='720' height='480'/%3E%3C/svg%3E",
    category: '交通协管',
    title: '路口的坚守与感动',
    excerpt: '交通协管员刘阿姨每天在路口指挥交通8小时,烈日下汗水浸湿了衣服。志愿者送来的水让她倍感温暖:"有你们的支持,我们的工作更有意义..."',
    views: 7654,
    date: '2026-06-08',
  },
];
